import React, { lazy } from 'react';

import { Route } from 'react-router-dom';

const GuardianILPLandingPage = lazy(
  () =>
    import(
      /* webpackChunkName: 'guardian-ilp-landing-page' */ 'modules/PersonalizedPlans/pages/GuardianILPLandingPage'
    ),
);

const NewPassword = lazy(
  () =>
    import(
      /* webpackChunkName: 'new-password' */ 'modules/Authentication/components/NewPasswordV2'
    ),
);

const Logout = lazy(
  () =>
    import(/* webpackChunkName: 'logout' */ 'modules/Authentication/Logout'),
);

const NotAuthorized = lazy(
  () =>
    /* webpackChunkName: not-authorized */ import('components/Common/Error403'),
);

const UnauthenticatedSupervisorPage = lazy(
  () =>
    import(
      /* webpackChunkName: 'unauthenticated-supervisor-page' */ 'modules/ExperienceTracking/UnauthenticatedSupervisorPage'
    ),
);

const PersonalizedPlans = lazy(
  () =>
    import(
      /* webpackChunkName: 'personalized-plans' */ 'modules/PersonalizedPlans'
    ),
);

const AuthRoutes = () => (
  <>
    <Route
      path="/guardian-ilp-approval/:clientId/:clientSecret/:studentIlpId"
      element={<GuardianILPLandingPage />}
    />
    <Route path="/logout" element={<Logout />} />,
    <Route path="/access-denied" element={<NotAuthorized />} />
    <Route
      path="/experience-tracking/supervisor/:sessionUuid/"
      element={<UnauthenticatedSupervisorPage />}
    />
    <Route
      path="/experience-tracking/supervisor/"
      element={<UnauthenticatedSupervisorPage />}
    />
    <Route path="/plans/*" element={<PersonalizedPlans />} />,
    <Route path="/new-password" element={<NewPassword />} />,
  </>
);

export default AuthRoutes;
